import { render, staticRenderFns } from "./pop.vue?vue&type=template&id=248c960f&scoped=true&"
import script from "./pop.vue?vue&type=script&lang=js&"
export * from "./pop.vue?vue&type=script&lang=js&"
import style0 from "./pop.vue?vue&type=style&index=0&id=248c960f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c960f",
  null
  
)

export default component.exports